import { render, staticRenderFns } from "./CanvasField.vue?vue&type=template&id=4014aff8&scoped=true"
import script from "./CanvasField.vue?vue&type=script&lang=js"
export * from "./CanvasField.vue?vue&type=script&lang=js"
import style0 from "./CanvasField.vue?vue&type=style&index=0&id=4014aff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014aff8",
  null
  
)

export default component.exports